import React, { useEffect, useState } from 'react';
import Alert from '@material-ui/lab/Alert';
import { beginDirectSso } from '../../auth/pcAuthBrowserFlow';

const normalizeEmail = (value) => (value || '').trim().toLowerCase();

const getDomainFromEmail = (email) => {
  const normalizedEmail = normalizeEmail(email);
  const [, domain] = normalizedEmail.split('@');
  return domain || '';
};

const getProvider = (queryProvider, email, queryDomain) => {
  if (queryProvider) {
    return queryProvider;
  }

  const domain = (queryDomain || getDomainFromEmail(email)).trim().toLowerCase();
  if (domain === 'duracell.com' || domain === 'phishcloudinc.onmicrosoft.com') {
    return 'microsoft';
  }

  return 'google';
};

const PcAuthStart = () => {
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    const query = new URLSearchParams(window.location.search);
    const email = normalizeEmail(query.get('email') || '');
    const domain = (query.get('domain') || '').trim().toLowerCase();
    const tenant = (query.get('tenant') || '').trim().toLowerCase();
    const provider = getProvider((query.get('provider') || '').trim().toLowerCase(), email, domain);
    const returnTo =
      (query.get('returnTo') || '').trim() ||
      (localStorage.getItem('intendedRoute') || '').trim() ||
      '/Dashboard/History';

    try {
      beginDirectSso({
        provider,
        email,
        domain,
        tenant,
        returnTo,
      });
    } catch (error) {
      setErrorMessage(error?.message || 'Unable to start sign-in.');
    }
  }, []);

  return (
    <div style={{ margin: '2rem', maxWidth: '640px' }}>
      {errorMessage ? (
        <Alert severity="error">{errorMessage}</Alert>
      ) : (
        <Alert severity="info">Starting single sign-on...</Alert>
      )}
    </div>
  );
};

export default PcAuthStart;
